export { Faqs } from "./Faqs"
